@if (isDebug) {
  <div class="debug" [class.pane-visible]="isVisible">
    #{{ item.order }} Debug info -> формат: {{ format }}, учитываем данные: {{ hasContent }}, показываем:
    {{ isVisible }}
    @if (item.payload__debug) {
      <div>
        Фильтрация (v2):
        <ul>
          @for (item of item.payload__debug; track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      </div>
    }
  </div>
}

<ng-container *ngIf="isStuckCategories(); else pane">
  <div
    #panePosition
    class="library-pane"
    [ngClass]="format"
    [class.visible]="isVisible"
    [ngStyle]="{ top: topFromHeader + 'px' }"
    [class.stuck-shadow]="stuckState"
    [class.is-lessons]="isLessonsPage"
    [class.mobile]="!deviceService.isDesktop()">
    <ng-container #viewPane></ng-container>
    <div #scrollSentinel style="height: 1px"></div>
  </div>
</ng-container>

<ng-template #pane>
  <div
    class="library-pane"
    [ngClass]="[format, item.display_mode && deviceService.isMobile() ? item.display_mode : '']"
    [class.visible]="isVisible"
    [class.mobile]="!deviceService.isDesktop()">
    <ng-container #viewPane></ng-container>
    <div #scrollSentinel style="height: 1px"></div>
  </div>
</ng-template>
